import React from 'react';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Box from '@amzn/meridian/box';

interface FeedbackQuestionProps {
  questionNumber: number;
  questionText: React.ReactNode;
  helperText?: React.ReactNode;
  required?: boolean;
  children: React.ReactNode;
}

const FeedbackQuestion: React.FC<FeedbackQuestionProps> = ({
  questionNumber,
  questionText,
  required = false,
  helperText,
  children,
}) => {
  return (
    <Column
      spacing='none'
      spacingInset='none'
      alignmentHorizontal='start'
      alignmentVertical='top'
      width='100%'
    >
      <Column
        spacingInset={!helperText ? 'none none 350 none' : 'none'}
        spacing='none'
      >
        <Text type='h100' alignment='start'>
          {questionNumber}. {questionText}
          {required && '*'}
        </Text>
        {helperText && (
          <Box spacingInset='300 none 200 none'>
            <Text type='b200' color='secondary'>
              {helperText}
            </Text>
          </Box>
        )}
      </Column>
      {children}
    </Column>
  );
};

export default FeedbackQuestion;
